module.exports = __webpack_public_path__ + "img/linkedin.49f995a1.svg";